import { useTitle } from "../../hooks/useTitle";

export const Schedule = () => {
  useTitle('Schedule')
  return <>Schedule component</>;
};
